export const API_BASE = "/api";

const request = async (url, method = "POST", body = {}) => {
  const response = await fetch(`${API_BASE}${url}`, {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || "Request failed");
  }

  return data;
};

export const sendEmailOTP = (email) =>
  request("/send-email-otp", "POST", { email });

export const verifyEmailOTP = (email, otp) =>
  request("/verify-email-otp", "POST", { email, otp });

export const verifyGoogleToken = (token) =>
  request("/verify-google-token", "POST", { token });

export const createLead = (data) =>
  request("/leads", "POST", data);

export const createEnrollment = (data) =>
  request("/enrollments", "POST", data);